var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemolitionDrywall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "DemolitionDrywall_svg__Lager_8",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "2 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .DemolitionDrywall_svg__st0{fill:none;stroke-width:.75;stroke-miterlimit:10}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 12.2 24.1-2.3M3.3 13.7l23.9-2.3M3.5 19.6l24.4-2.3m-24 3.8L28 18.7m-7.3-.6-.6-5.9m-6.8 6.4-.5-5.9m1.5 16.9-.8-9m-1.8-1.9-.5-5.9m1.4 17-.8-9.1M11 11l-.7-8.4M28.9 28 4.8 30.6 2.5 2.9l24.2-1.5zm-7.2 1-.8-9.1",
    className: "DemolitionDrywall_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 1.9V2l.8 8.6m-.9 7.6-.5-5.9m1.6 17-.9-9.4M17.7 2.3l.7 7.6.1.8m-5.8.5-.8-8.5",
    className: "DemolitionDrywall_svg__st0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemolitionDrywall);
export default __webpack_public_path__ + "static/media/DemolitionDrywall.81b8984ed542ad50b4ea60b83bf65ac1.svg";
export { ForwardRef as ReactComponent };